/**
 * EmailTemplateSection.tsx
 * メールテンプレート送信ボタン群（AI作成 / 決済御礼 / フリー / リクエスト系 / キャンセル系 / コメント返信）
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import { emailTemplateLabel } from '../constants';
import { getStoreKey } from '../../../config/backend';

interface EmailTemplateSectionProps extends SectionProps {
  onOpenEmailTemplate?: (type: string) => void;
}

// ラベルの正は constants.ts の EMAIL_TEMPLATE_LABELS（送信後の予約メモ記録と共有）。
// ここではボタンの並び順だけを持つ。
const AI_COMPOSE_TEMPLATE = { type: 'ai_compose', label: `✨ ${emailTemplateLabel('ai_compose')}` } as const;

const EMAIL_TEMPLATE_ORDER = [
  'payment', 'free', 'request_ok', 'request_ok_night', 'request_full', 'request_offer', 'cancel', 'cancel_fee', 'comment',
] as const;

// 宮古は深夜・早朝の対応がない（営業 9:00〜20:00・深夜料金なし）ので「深夜早朝OK」は出さない（2026-10-03）
const EMAIL_TEMPLATES = EMAIL_TEMPLATE_ORDER
  .filter((type) => !(type === 'request_ok_night' && getStoreKey() === 'pit'))
  .map((type) => ({ type, label: emailTemplateLabel(type) }));

const STANDARD_BUTTON_STYLE: React.CSSProperties = {
  padding: '4px 12px',
  fontSize: '0.75rem',
  border: 'none',
  borderRadius: 4,
  background: '#475569',
  color: '#fff',
};

const AI_BUTTON_STYLE: React.CSSProperties = {
  padding: '6px 14px',
  fontSize: '0.8rem',
  fontWeight: 600,
  border: 'none',
  borderRadius: 4,
  background: 'linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)',
  color: '#fff',
  boxShadow: '0 1px 3px rgba(99, 102, 241, 0.4)',
};

export default function EmailTemplateSection({
  disabled,
  isNew,
  onOpenEmailTemplate,
}: EmailTemplateSectionProps) {
  if (isNew || !onOpenEmailTemplate) return null;

  return (
    <>
      <SectionHeader title="メールテンプレート" />
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', padding: '8px 4px' }}>
        {/* AIで作成: トップ表示・色違いで目立たせる */}
        <button
          type="button"
          onClick={() => onOpenEmailTemplate(AI_COMPOSE_TEMPLATE.type)}
          disabled={disabled}
          style={{
            ...AI_BUTTON_STYLE,
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
          }}
        >
          {AI_COMPOSE_TEMPLATE.label}
        </button>
        {EMAIL_TEMPLATES.map((tpl) => (
          <button
            key={tpl.type}
            type="button"
            onClick={() => onOpenEmailTemplate(tpl.type)}
            disabled={disabled}
            style={{
              ...STANDARD_BUTTON_STYLE,
              cursor: disabled ? 'default' : 'pointer',
            }}
          >
            {tpl.label}
          </button>
        ))}
      </div>
    </>
  );
}
